import React from "react";

export default function Summary(props) {
  const form = props.form;
  const product = props.product;

  const leaseDate = `${form.lease_start_date.getDate()}/${form.lease_start_date.getMonth() + 1}/${form.lease_start_date.getFullYear()}`
  const tempDate = new Date(form.lease_start_date.getTime());
  tempDate.setMonth(tempDate.getMonth() + parseInt(form.fixed_term));
  const changeDate = `${tempDate.getDate()}/${tempDate.getMonth() + 1}/${tempDate.getFullYear()}`;

  const goToPremises = () => {
    props.setPage(2);
  };

  const goToBuyer = () => {
    props.setPage(3);
  };

  return (
    <div className="">
      <div className="flex justify-between sm:flex-row xs:flex-col">
        <h4 className="text-2xl px-4 font-semibold mb-8">Summary</h4>
        <h4 className="text-xl px-4 font-semibold mb-8 ">
          ${product.totalPrice}
        </h4>
      </div>

      <div className="flex justify-between">
        <h4 className="text-md px-4 font-semibold mb-4">Premises Details</h4>
        <button
          onClick={goToPremises}
          className="text-[#3059a9] text-sm hover:underline"
        >
          Edit
        </button>
      </div>
      <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Address Line 1
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.premises_address_line_1}
            </dd>
          </div>
          <div
            className={
              form.premises_address_line_2
                ? "py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                : "hidden"
            }
          >
            <dt className="text-sm font-medium text-gray-500">
              Address Line 2
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.premises_address_line_2}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Suburb</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.premises_suburb}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">State</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.premises_state}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Postcode</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.premises_postcode}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Rent Amount</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              ${form.rent_amount}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Rent Frequency</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.rent_frequency}ly
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Lease Period</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.fixed_term} months
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Lease Date</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {leaseDate}
            </dd>
          </div>

          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Change Date</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {changeDate}
            </dd>
          </div>
        </dl>
      </div>

      <div className="flex justify-between">
        <h4 className="text-md px-4 font-semibold mt-4 mb-4">Payment Details</h4>
        <button
          onClick={goToBuyer}
          className="text-[#3059a9] text-sm hover:underline"
        >
          Edit
        </button>
      </div>

      <div className=" border-gray-200 border-t px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Name</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.name}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Email</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.email}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Address Line 1
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.address_line_1}
            </dd>
          </div>
          <div
            className={
              form.address_line_2
                ? "py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                : "hidden"
            }
          >
            <dt className="text-sm font-medium text-gray-500">
              Address Line 2
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.address_line_2}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Suburb</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.suburb}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">State</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.state}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Postcode</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {form.postcode}
            </dd>
          </div>
        </dl>
      </div>

      <div className="flex justify-between">
        <h4 className="text-md px-4 font-semibold mt-4 mb-4">Pricing</h4>
      </div>
      <div className=" border-gray-200 border-t px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Form Price</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              ${product.price}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">G.S.T</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              ${(product.price / 10).toFixed(2)}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Total</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              ${product.totalPrice}
            </dd>
          </div>
        </dl>
      </div>

      <div className="text-center flex justify-between mt-6">
        <button
          className="text-white bg-black focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={props.prevStep}
        >
          Back
        </button>
        <button
          className="text-white bg-[#3059a9] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={props.nextStep}
        >
          Payment
        </button>
      </div>
    </div>
  );
}
